import React from 'react'
import { func, bool, string } from 'prop-types'
import {
  PASSWORD_CHANGE_TITLE,
  GENERIC_PASSWORD_CHANGE_ERROR
} from '../../constants/ui.labels'
import { SETTINGS_PAGE } from '../../constants/links'
import { ContentHeader, ChangePasswordForm, Error } from '../../components'
import mapError from '../../utils/mapError/userManagement'
import redirectTo from '../../utils/redirect/redirectTo'

export default class ChangePassword extends React.PureComponent {
  static propTypes = {
    onSubmit: func.isRequired,
    errorCode: string,
    processed: bool.isRequired,
    disabledForm: bool.isRequired
  }

  static defaultProps = {
    errorCode: null,
    disabledForm: false
  }

  state = {
    oldPassword: '',
    password: '',
    passwordConfirmation: '',
    error: null,
    isValid: false,
    toastError: true
  }

  hasAllPasswordsPresent = () => !!this.state.oldPassword && this.state.isValid

  onFormChange = formData => this.setState({ ...formData })

  getErrorMessage = errorCode =>
    this.state.error ||
    (errorCode && mapError(errorCode, GENERIC_PASSWORD_CHANGE_ERROR))

  onFormSubmit = event => {
    event.preventDefault()

    const { oldPassword, password } = this.state
    const { onSubmit } = this.props
    onSubmit({
      oldPassword,
      password
    })
    this.setState({ displayToastError: true })
  }

  createToastError = errorCode => {
    return <Error message={this.getErrorMessage(errorCode)} />
  }

  render() {
    const { processed, errorCode, disabledForm } = this.props
    const { oldPassword, password, passwordConfirmation } = this.state
    return !processed ? (
      <React.Fragment>
        <ContentHeader title={PASSWORD_CHANGE_TITLE} />
        {(this.state.error && !this.state.isValid) ||
        this.state.displayToastError
          ? this.createToastError(errorCode)
          : null}
        {
          <ChangePasswordForm
            oldPassword={oldPassword}
            password={password}
            passwordConfirmation={passwordConfirmation}
            onFormChange={this.onFormChange}
            onSubmit={this.onFormSubmit}
            disabledForm={disabledForm}
            isValid={this.hasAllPasswordsPresent()}
          />
        }
      </React.Fragment>
    ) : (
      redirectTo(SETTINGS_PAGE)
    )
  }
}
